export default __webpack_public_path__ + "static/media/pass-tune.75e54d64.mp3";